import { styled } from '@topwrite/common';
import { ReactNode } from 'react';
import { BsCheck2Circle, BsCircle, BsClock } from 'react-icons/bs';
import Collapse from './collapse';
import { useContext } from './context';

export default function TodoList() {
    const { todos } = useContext();
    if (todos.length == 0) {
        return null;
    }
    const completed = todos.filter(todo => todo.status === 'completed').length;
    return <Collapse title={`待办事项 (${completed}/${todos.length})`}>
        <Container>
            {todos.map((todo, index) => {
                // 根据状态显示不同的图标和样式
                let statusIcon: ReactNode = null;
                let statusClass: string = '';

                switch (todo.status) {
                    case 'completed':
                        statusIcon = <BsCheck2Circle className='text-success' />;
                        statusClass = 'completed';
                        break;
                    case 'in_progress':
                        statusIcon = <BsClock className='text-warning' />;
                        statusClass = 'in-progress';
                        break;
                    case 'pending':
                    default:
                        statusIcon = <BsCircle className='text-muted' />;
                        statusClass = 'pending';
                        break;
                }

                return <TodoItem key={index} className={`d-flex align-items-center gap-2 p-2 ${statusClass}`}>
                    <div className='flex-shrink-0 d-flex align-items-center'>
                        {statusIcon}
                    </div>
                    <div className='flex-grow-1'>
                        <TodoContent className={todo.status === 'completed' ? 'text-decoration-line-through text-muted' : ''}>
                            {todo.content}
                        </TodoContent>
                    </div>
                </TodoItem>;
            })}
        </Container>
    </Collapse>;
}


const Container = styled.div`
    background: var(--ttw-priview-background);
    max-height: 300px;
    overflow-y: auto;
`;

const TodoItem = styled.div`
    border-bottom: 1px solid var(--bs-border-color);
    transition: background-color 0.2s ease;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: var(--bs-light);
    }

    &.completed {
        opacity: 0.7;
    }

    &.in-progress {
        border-left: 3px solid var(--bs-warning);
    }
`;

const TodoContent = styled.div`
    line-height: 1.4;
    word-break: break-word;
`;
